"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatIssuePath = formatIssuePath;
exports.parseConfigDocument = parseConfigDocument;
/** `["acos", 0, "practices", 1, "tin"]` → `acos[0].practices[1].tin`. */
function formatIssuePath(path) {
    return path.reduce((out, key) => {
        if (typeof key === "number")
            return `${out}[${key}]`;
        return out === "" ? String(key) : `${out}.${String(key)}`;
    }, "");
}
/** Parses one document and reports each Zod issue against `document` with its formatted path. */
function parseConfigDocument(schema, document, input) {
    const result = schema.safeParse(input);
    if (result.success)
        return { success: true, data: result.data };
    return {
        success: false,
        issues: result.error.issues.map((issue) => ({
            document,
            path: formatIssuePath(issue.path),
            message: issue.message,
        })),
    };
}
//# sourceMappingURL=config-issue.js.map